import { render, staticRenderFns } from "./sidenavTile.vue?vue&type=template&id=81f9fb2c&scoped=true&"
import script from "./sidenavTile.vue?vue&type=script&lang=js&"
export * from "./sidenavTile.vue?vue&type=script&lang=js&"
import style0 from "./sidenavTile.vue?vue&type=style&index=0&id=81f9fb2c&scoped=true&lang=css&"
import style1 from "./sidenavTile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f9fb2c",
  null
  
)

export default component.exports